interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact filled check-circle asset from the Select Scenario Figma dropdown. */
const FigmaCheckCircleIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16.0029 15.9999'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.0028 0C12.4203 0 16.0028 3.58248 16.0028 7.99996C16.0028 12.4174 12.4203 15.9999 8.0028 15.9999C3.58532 15.9999 0.00283662 12.4174 0.00283662 7.99996C0.00283662 3.58248 3.58532 0 8.0028 0ZM6.34151 10.5984L4.38292 8.6382C4.04925 8.30433 4.04918 7.75988 4.38292 7.42607C4.71673 7.09233 5.26361 7.09442 5.59499 7.42607L6.97578 8.80794L10.4107 5.373C10.7445 5.03919 11.2891 5.03919 11.6228 5.373C11.9566 5.70674 11.9561 6.25173 11.6228 6.58507L7.58084 10.627C7.24751 10.9604 6.70251 10.9608 6.36877 10.627C6.35939 10.6177 6.35034 10.6081 6.34151 10.5984Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaCheckCircleIcon;
